import React, { useEffect, useState } from 'react';
import './Anketa.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { saveAnketa } from '../Slots/slotsApi';

function Anketa() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';
    const location = useLocation();
    const navigate = useNavigate();

    const slot = location.state?.slot;
    console.log('slot', slot)

    const [showModal, setShowModal] = useState(true);
    const [showModalAgreement, setShowModalAgreement] = useState(false);

    const slotDate = new Date(slot.datetime).toLocaleString('ru-RU', {
        weekday: 'long',
        day: '2-digit',
        month: 'long',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Moscow'
    });

    const status = slot.status || 'неизвестно';

    const [previews, setPreviews] = useState([]); // локальные превью

    const [form, setForm] = useState({
        fullName: '',
        phone: '',
        country: '',
        diagnosis: '',
        intention: '',
        agreebyname: '',
        retreat: null,
        photos: [],
        age: '',
        checkAgreement1: false,
        checkAgreement2: false,
        checkAgreement3: false,
        checkAgreement4: false,
        checkAgreement5: false,
        checkAgreement6: false,
        checkAgreement7: false,
        presence: '',               // 'yes' или 'no'
        presenceAgreement: false,   // true если согласен
        presenceReason: '',         // если выбрано "нет"
    });

    const [relation, setRelation] = useState('');

    const options = ['Родитель', 'Опекун', 'Я исцеляемый(ая)'];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    // const handleFileChange = (e) => {
    //     const files = Array.from(e.target.files).slice(0, 5);
    //     setForm((prev) => ({ ...prev, photos: files }));
    // };


    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);

        if (files.length > 5) {
            alert('Можно загрузить не более 5 фото');
            return;
        }

        const totalSizeMB = files.reduce((sum, file) => sum + file.size, 0) / (1024 * 1024);
        if (totalSizeMB > 10) {
            alert('Общий размер файлов не должен превышать 10MB');
            return;
        }

        setForm(prev => ({ ...prev, photos: files }));

        // Генерация локальных ссылок для предпросмотра
        const localPreviews = files.map(file => URL.createObjectURL(file));
        setPreviews(localPreviews);
    };



    const handleRetreatClick = (answer) => {
        setForm((prev) => ({ ...prev, retreat: answer }));
    };

    const handleCancel = () => {
        // Здесь может быть логика отмены слота
        alert('Вы отказались от слота.');
    };

    function validateForm(form) {
        const missingFields = [];

        if (!form.fullName.trim()) missingFields.push('ФИО');
        if (!form.phone.trim()) missingFields.push('Телефон');
        if (!form.country.trim()) missingFields.push('Страна');
        if (!form.intention.trim()) missingFields.push('Намерение');
        if (form.retreat === null) missingFields.push('Информация о ретритах');
        if (!form.photos || form.photos.length === 0) missingFields.push('Фото');



        if (missingFields.length > 0) {
            return `Пожалуйста, заполните обязательные поля: ${missingFields.join(', ')}.`;
        }


        return null; // Всё ок
    }

    function validateFormAgree(form) {
        const missingFields = [];



        const allAgreementsChecked =
            form.checkAgreement1 &&
            form.checkAgreement2 &&
            form.checkAgreement3 &&
            form.checkAgreement4 &&
            form.checkAgreement5 &&
            form.checkAgreement6 &&
            form.checkAgreement7;



        if (!allAgreementsChecked) {
            return 'Пожалуйста, подтвердите все соглашения (все галочки должны быть отмечены).';
        }

        return null; // Всё ок
    }


    function prepareFormData(anketId, form, relation) {
        const formData = new FormData();

        formData.append('anketId', anketId);
        formData.append('fullName', form.fullName || '');
        formData.append('phone', form.phone || '');
        formData.append('country', form.country || '');
        formData.append('diagnosis', form.diagnosis || '');
        formData.append('intention', form.intention || '');
        formData.append('agreebyname', form.agreebyname || '');
        formData.append('retreat', form.retreat ? '1' : '0');
        formData.append('age', form.age || '');
        formData.append('relation', relation || '');

        formData.append('presence', form.presence || '');
        formData.append('presenceAgreement', form.presenceAgreement ? '1' : '0');
        formData.append('presenceReason', form.presenceReason || '');

        if (form.photos && form.photos.length > 0) {
            form.photos.forEach(photo => {
                formData.append('photos', photo);
            });
        }

        return formData;
    }


    const handleSave = async () => {
        const validationError = validateForm(form);
        if (validationError) {
            alert(validationError);
            return;
        }

        // try {
        //     const formData = prepareFormData(slot.anket_id, form, relation);
        //     await saveAnketa(slot.anket_id, formData);
        //     alert('Анкета сохранена успешно!');
        //     navigate('/myslots');
        // } catch (error) {
        //     console.error('Ошибка сохранения анкеты:', error);
        //     alert('Ошибка при сохранении анкеты');
        // }
        setShowModalAgreement(true)
    };

    const handleAgree = async () => {
        const validationError = validateFormAgree(form);
        if (validationError) {
            alert(validationError);
            return;
        }

        try {
            const formData = prepareFormData(slot.anket_id, form, relation);
            await saveAnketa(slot.anket_id || slot.id, formData);
            // alert('Анкета сохранена успешно!');
            navigate('/myslots');
        } catch (error) {
            console.error('Ошибка сохранения анкеты:', error);
            alert('Ошибка при сохранении анкеты');
        }

        setShowModalAgreement(false)
    };

    const handlePresenceClick = (value) => {
        setForm(prev => ({
            ...prev,
            presence: value,
            presenceAgreement: false,
            presenceReason: '',
        }));
    };

    const handleCheckboxPresenceChange = (e) => {
        const { name, checked } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: checked,
        }));
    };

    const handleRemovePhoto = (indexToRemove) => {
        setForm(prev => ({
            ...prev,
            photos: prev.photos.filter((_, index) => index !== indexToRemove),
        }));

        setPreviews(prev => {
            // Освобождаем ссылку
            URL.revokeObjectURL(prev[indexToRemove]);
            return prev.filter((_, index) => index !== indexToRemove);
        });
    };

    useEffect(() => {
        if (!slot) return;

        setForm((prev) => ({
            ...prev,
            fullName: slot.fullName || '',
            phone: slot.phone || '',
            country: slot.country || '',
            diagnosis: slot.diagnosis || '',
            intention: slot.intention || '',
            agreebyname: slot.agreebyname || '',
            retreat: slot.retreat ?? null,
            photos: slot.photos ? slot.photos.split('|') : [],
            age: slot.age || '',
            presence: slot.presence || '',
            presenceAgreement: !!slot.presenceAgreement,
            presenceReason: slot.presenceReason || '',
        }));

        setRelation(slot.relation || '');

        if (slot.photos) {
            const fullUrls = slot.photos.split('|').map(path => `${API_BASE_URL}${path}`);
            setPreviews(fullUrls);
        }
    }, [slot]);

    if (!slot) return <div>Слот не передан</div>;

    console.log('slot', slot)



    return (
        <div className="anketa-container">
            {showModal && (
                <div className="modal-overlay">
                    <div className="modal-content-anketa">
                        <p>
                            Для того, чтобы ваш сеанс состоялся, Вам необходимо заполнить Анкету до конца,
                            сохранить её и убедиться, что все необходимые поля заполнены.
                        </p>
                        <p><strong>Чтобы убедиться, что Ваша анкета заполнена до конца и отправлена нам:</strong></p>
                        <ol>
                            <li>
                                После того, как Вы заполнили анкету и нажали на кнопку <strong>СОХРАНИТЬ</strong>,
                                находящуюся в конце анкеты, Вы получите уведомление от анкеты в отдельном окне, которое сообщит, что анкета заполнена.
                            </li>
                            <li>
                                Если Вы посмотрите в разделе <strong>МОИ СЛОТЫ</strong> и найдёте там исцеление,
                                на которое Вы только что заполнили анкету – это будет означать, что анкета заполнена и мы получили её.
                            </li>
                        </ol>
                        <p><u>В противном случае наша система автоматически аннулирует Ваш сеанс в течение 3 часов с момента выбора Вами даты исцеления.</u></p>

                        <p>Получение исцеления в группе любящих и заботливых людей — это особенное событие.</p>
                        <p>Интеграция энергии, полученной во время сеанса, будет происходить в течение определенного периода времени.</p>
                        <p>
                            Мы призываем Вас взять на себя ответственность за свою жизнь и свое исцеление и не перекладывать ее на кого-либо еще,
                            включая доктора Джо Диспензу и участников группы Когерентного Исцеления.
                        </p>
                        <p>
                            Мы рекомендуем Вам выполнять практики, предложенные доктором Джо – медитировать,
                            читать книги, проходить онлайн-курсы и знакомиться с историями исцеления на YouTube.
                        </p>
                        <p>
                            Вы можете найти ресурсы на сайтах: <br />
                            <a href="https://drjoedispenza.com" target="_blank" rel="noreferrer">drjoedispenza.com</a>,{' '}
                            {/* <a href="https://drjoedispenza.ru" target="_blank" rel="noreferrer">drjoedispenza.ru</a> */}
                        </p>

                        <button className="btn_anketa" onClick={() => setShowModal(false)}>Далее</button>
                    </div>
                </div>
            )}
            {showModalAgreement && (
                <div className="modal-overlay">
                    <div className="modal-content-anketa">
                        <div>
                            <p>Отказ от Предъявления Претензий, Освобождение от Ответственности и Предоставление Разрешения на Исцеление («Соглашение»)

                                Настоящее Соглашение составлено юристами доктора Джо Диспенза на основании законов США и переведено нами на русский язык.

                                Я, («Исцеляемый(ая)»), принимая во внимание мое Участие в сеансе Когерентного Исцеления,
                                проводимое уполномоченной группой («Уполномоченная группа»),
                                соглашаюсь лично соблюдать вышеназванное Соглашение и поручаюсь за моих представителей, исполнителей,
                                наследников, членов семьи, правопреемников,
                                что они тоже будут соблюдать данное Соглашение, а также признаю, соглашаюсь и разрешаю следующее:
                            </p>
                            <p>
                                1. Я понимаю,
                                что Уполномоченная Группа проводит Исцеления с минимальной периодичностью и минимальным соотношением Целителей и Исцеляемых,
                                используя при этом только учения доктора Джо Диспензы.
                                Однако этот процесс не зависит и не находится под непосредственным контролем д-ра Джо Диспензы или Encephalon,
                                Inc., включая их филиалы, должностных лиц, сотрудников, агентов,
                                преемников и правопреемников (д-р Джо Диспенза и Encephalon вместе именуются «Энцефалон»),
                                а также от участников Уполномоченной группы. Кроме этого, я понимаю,
                                что у каждой официальной Авторизованной целительской группы (уполномоченной группы)
                                существуют свои собственные процедуры и политика,
                                отдельные от Encephalon.
                            </p>

                            <label>
                                <input
                                    type="checkbox"
                                    name="checkAgreement1"
                                    checked={form.checkAgreement1}
                                    onChange={handleCheckboxChange}
                                />
                                Согласен (согласна) *
                            </label>

                            <p>
                                2. Я желаю участвовать в сеансе Когерентного Исцеления («Участие») ДОБРОВОЛЬНО.
                                Мое Участие и исполнение настоящего Соглашения являются ДОБРОВОЛЬНЫМИ.
                                Я ознакомился(ась), полностью понимаю и обязуюсь юридически соблюдать условия этого Соглашения.
                            </p>
                            <label>
                                <input
                                    type="checkbox"
                                    name="checkAgreement2"
                                    checked={form.checkAgreement2}
                                    onChange={handleCheckboxChange}
                                />
                                Согласен (согласна) *
                            </label>

                            <p>
                                3. Я также понимаю, что существует определенный уровень риска,
                                связанный с моим последующим Участием в Исцелении,
                                и, что реакцию моего организма на различные действия,
                                применяемые при Исцелении, невозможно предсказать с полной точностью и в полном объеме. Я понимаю степень риска отрицательной реакции организма, вызванной моим Участием в Исцелении. НАСТОЯЩИМ Я ПРИЗНАЮ И ПРИНИМАЮ НА СЕБЯ РИСКИ, СВЯЗАННЫЕ С УЧАСТИЕМ в Исцелении. Я согласен(на) с тем, что несу ответственность за любые травмы, ущерб или потерю имущества, возникшие в результате моего Участия, и я согласен(на) с тем, что буду нести единоличную ответственность за любые медицинские расходы и другие расходы, возникающие в связи с этим.




                            </p>
                            <label>
                                <input
                                    type="checkbox"
                                    name="checkAgreement3"
                                    checked={form.checkAgreement3}
                                    onChange={handleCheckboxChange}
                                />
                                Согласен (согласна) *
                            </label>

                            <p>
                                4. Я согласен(на) проконсультироваться со своим врачом и получить письменное медицинское заключение, если это необходимо,
                                в связи с определенным состоянием моего здоровья до Участия в Исцелении.
                                Если консультация врача не требуется, я заявляю, что нахожусь в адекватной физической и психологической форме для Участия,
                                и мне не известно о каких-либо заболеваниях или симптомах, которые могут помешать мне участвовать в Исцелении.
                                Я понимаю, что лечебный сеанс Когерентного Исцеления не заменяет традиционное медицинское лечение,
                                и я проконсультируюсь с моим врачом или другим соответствующим специалистом
                                в области здравоохранения и проведу дополнительное лечение,
                                являющееся частью полной программы здравоохранения.
                            </p>
                            <label>
                                <input
                                    type="checkbox"
                                    name="checkAgreement4"
                                    checked={form.checkAgreement4}
                                    onChange={handleCheckboxChange}
                                />
                                Согласен (согласна) *
                            </label>
                            <p>
                                5. Я согласен(на) с тем, что Уполномоченная группа не оказывает неотложную медицинскую помощь, медицинские консультации и не предписывает использование различных методов лечения в качестве формы лечения каких-либо психических, физических или медицинских проблем, прямо или косвенно.

                            </p>
                            <label>
                                <input
                                    type="checkbox"
                                    name="checkAgreement5"
                                    checked={form.checkAgreement5}
                                    onChange={handleCheckboxChange}
                                />
                                Согласен (согласна) *
                            </label>
                            <p>
                                6. Я беру на себя риск получения телесных повреждений, появления болезней или наступления смерти и соглашаюсь с тем,
                                что мое Участие в Исцелении всегда будет и остается на мой страх и риск и только я являюсь ответственным за свое Исцеление.
                                Я, ОТ СВОЕГО ИМЕНИ И ОТ ИМЕНИ МОИХ ЛИЧНЫХ ПРЕДСТАВИТЕЛЕЙ, ИСПОЛНИТЕЛЕЙ, НАСЛЕДНИКОВ, ЧЛЕНОВ СЕМЬИ, ПРАВОПРЕЕМНИКОВ,
                                НАСТОЯЩИМ СОЗНАТЕЛЬНО И ДОБРОВОЛЬНО ОБЯЗУЮСЬ НЕ ПОДАВАТЬ ИСКИ В СУДЕБНЫЕ ОРГАНЫ И ОБЯЗУЮСЬ ОТКАЗАТЬСЯ ОТ ПРЕТЕНЗИЙ И
                                ОСВОБОДИТЬ УПОЛНОМОЧЕННУЮ ГРУППУ и ЭНЦЕФАЛОН от любой ответственности, убытков, затрат, ущерба, расходов,
                                претензий или исков в отношении любых без исключения травм, убытков, болезней, смерти, вреда, расходов, претензий,
                                исков или ущерба, связанных с моим Участием в Исцелении, включая любые небрежные действия или поведение со стороны
                                Энцефалона или Уполномоченной группы (совместно именуемые «Претензии»).
                                Кроме того, я соглашаюсь возместить убытки, возникшие в следствие нарушения данного соглашения и оградить
                                Энцефалон и Уполномоченную группу от любых претензий третьих лиц,
                                связанных с моим Участием. В сеансе Когерентного Исцеления.


                            </p>

                            <label>
                                <input
                                    type="checkbox"
                                    name="checkAgreement6"
                                    checked={form.checkAgreement6}
                                    onChange={handleCheckboxChange}
                                />
                                Согласен (согласна) *
                            </label>

                            <p>
                                7. Условия Этого Соглашения настолько широки и всеобъемлющи, насколько это разрешено законами Российской Федерации и штата Вашингтон.
                                Если какая-либо часть настоящего Соглашения будет признана недействительной,
                                она в любом случае останется в полной юридической силе и действии.
                                Я подтверждаю, поставив отметку в поле ниже, что я прочитал, ознакомился и понял информацию, заявления,
                                соглашения, разрешения, указанных выше, и добровольно даю свое согласие на соблюдение данного Соглашения.
                            </p>
                            <label>
                                <input
                                    type="checkbox"
                                    name="checkAgreement7"
                                    checked={form.checkAgreement7}
                                    onChange={handleCheckboxChange}
                                />
                                Согласен (согласна) *
                            </label>

                            <p>
                                <b>ИСЦЕЛЯЕМЫЙ:</b> Пожалуйста, введите свое полное имя, фамилию и дату в качестве юридического подтверждения вашей подписи и
                                согласия с положениями настоящего Соглашения.<br></br>

                                <b>РОДИТЕЛЬ ИЛИ ОПЕКУН:</b> Я являюсь родителем, опекуном или поверенным по действующей доверенности от Исцеляемого,
                                действую от имени Исцеляемого и подтверждаю своей подписью согласие с положениями настоящего Соглашения. *
                            </p>

                            <input
                                type="text"
                                name="agreebyname"
                                value={form.agreebyname}
                                onChange={handleInputChange}
                                required
                            /><br></br><br></br>
                        </div>

                        <button className="btn_anketa" onClick={handleAgree}>Принять</button>
                    </div>
                </div>
            )}
            <div className="slot-info">
                <p className="slot-date">Слот на {slotDate}</p>
                {/* <p className="slot-status">Статус: <span className="status-value">{status}</span></p> */}
                {/* <button className="cancel-button" onClick={handleCancel}>
                    Отказаться от слота
                </button> */}
            </div>

            <div className="anketa-instructions">
                <br></br>

                <div className="anketa-form">
                    <label className="anketa-answer">
                        <b>
                            По рекомендациям доктора Джо Диспенза требуется Ваше личное присутствие на сеансе исцеления.
                        </b>
                        <br />
                        Если Вы не сможете присутствовать лично, пожалуйста отмените сеанс (используя соответствующую кнопку в меню <i>«Мои слоты»</i>) и запишитесь на другой день и удобное для вас время.<br />
                        <br />
                        <b>Ваше присутствие на сеансе — это уже 50% успеха!</b><br />
                        <br />
                        Планируете ли вы лично присутствовать на сеансе?
                    </label>

                    <div className="retreat-buttons">
                        <button
                            type="button"
                            className={form.presence === 'yes' ? 'active' : ''}
                            onClick={() => handlePresenceClick('yes')}
                        >
                            Да
                        </button>
                        <button
                            type="button"
                            className={form.presence === 'no' ? 'active' : ''}
                            onClick={() => handlePresenceClick('no')}
                        >
                            Нет
                        </button>
                    </div>

                    {/* ЕСЛИ "ДА" — согласие с условием */}
                    {form.presence === 'yes' && (
                        <div className="anketa-confirm">
                            <label>
                                <input
                                    type="checkbox"
                                    name="presenceAgreement"
                                    checked={form.presenceAgreement}
                                    onChange={handleCheckboxPresenceChange}
                                    required
                                />
                                {' '}Я согласен, что если я не буду присутствовать, мне будет отказано в последующей записи на сеансы!
                            </label>
                        </div>
                    )}

                    {/* ЕСЛИ "НЕТ" — причина */}
                    {form.presence === 'no' && (
                        <div className="anketa-reason">
                            <label>
                                Укажите причину (например, «Я буду на работе»):
                            </label>
                            <input
                                className="anketa_input"
                                type="text"
                                name="presenceReason"
                                value={form.presenceReason}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                    )}
                </div>

                <br></br>
                <div className="anketa-form">
                    <label className="anketa-answer">
                        <b>
                            Имя и фамилия исцеляемого: <span style={{ color: 'red' }}>*</span>
                        </b>
                    </label><br />

                    <input
                        className="anketa_input"
                        type="text"
                        name="fullName"
                        value={form.fullName}
                        onChange={handleInputChange}
                        required
                    /><br />


                    <small>Обязательно укажите имя и фамилию. Это необходимо для проведения исцеления</small><br></br><br></br>

                    <label className="anketa-answer">
                        <b>
                            Телефон исцеляемого: <span style={{ color: 'red' }}>*</span>
                        </b><br />
                        <input
                            className="anketa_input"
                            type="tel"
                            name="phone"
                            value={form.phone}
                            onChange={handleInputChange}
                            required
                        /><br />
                        <small>Заполняется с кодом страны и необходим для экстренной связи</small>
                    </label><br /><br />


                    <label className="anketa-answer">
                        <b>
                            В какой стране вы проживаете? <span style={{ color: 'red' }}>*</span>
                        </b><br />
                        <input
                            className="anketa_input"
                            type="text"
                            name="country"
                            value={form.country}
                            onChange={handleInputChange}
                            required
                        />
                    </label><br /><br />


                    <div>
                        <label className="anketa-answer">
                            <b>
                                Фото: <span style={{ color: 'red' }}>*</span>
                            </b><br />
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                onChange={handleFileChange}
                            /><br />
                            <small>
                                Мы показываем это фото целителям во время сеанса исцеления. Всего можно загрузить не более 5 фото.
                            </small>
                        </label><br /><br />
                    </div>

                    {/* Превью загруженных фото */}
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '30px' }}>
                        {previews.map((src, index) => (
                            <div key={index} style={{ position: 'relative', width: '15vw', height: '15vw' }}>
                                <img
                                    src={src}
                                    alt={`Фото ${index + 1}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                        border: '1px solid #ccc'
                                    }}
                                />
                                <button
                                    type="button"
                                    onClick={() => handleRemovePhoto(index)}
                                    style={{
                                        position: 'absolute',
                                        top: '-8px',
                                        right: '-8px',
                                        background: 'red',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '20px',
                                        height: '20px',
                                        cursor: 'pointer',
                                        fontWeight: 'bold',
                                        lineHeight: '18px',
                                        padding: 0
                                    }}
                                    title="Удалить фото"
                                >
                                    ×
                                </button>
                            </div>

                        ))}
                    </div>


                    <div>
                        <label className="anketa-answer">
                            <b>Диагноз исцеляемого:</b><br />
                            <textarea
                                className="anketa_input txtar"
                                name="diagnosis"
                                value={form.diagnosis}
                                onChange={handleInputChange}
                                rows="4"
                            /><br />
                            <small>Заполняется по желанию, помогает нам понять степень срочности исцеления</small>
                        </label>
                    </div><br></br>

                    <div>
                        <label className="anketa-answer">
                            <b>
                                Посещали ли вы какие-либо недельные ретриты доктора Джо Диспензы?
                                <span style={{ color: 'red' }}>*</span>
                            </b><br />
                            <div className="retreat-buttons">
                                <button
                                    type="button"
                                    className={form.retreat === 'yes' ? 'active' : ''}
                                    onClick={() => handleRetreatClick('yes')}
                                >
                                    Да
                                </button>
                                <button
                                    type="button"
                                    className={form.retreat === 'no' ? 'active' : ''}
                                    onClick={() => handleRetreatClick('no')}
                                >
                                    Нет
                                </button>
                            </div>
                        </label>
                    </div><br></br>

                    <label className="anketa-answer">
                        <b>
                            Намерение: <span style={{ color: 'red' }}>*</span>
                        </b>
                    </label><br />
                    <textarea
                        className="anketa_input txtar"
                        name="intention"
                        value={form.intention}
                        onChange={handleInputChange}
                        maxLength={300}
                        rows="5"
                    />
                    <div className="char-count">Символов {form.intention.length}/300</div>


                </div>

                <p>Пожалуйста, представьте нам от 1 до 3 намерений, описывающих, как исцеляемый видит свое будущее и чего желает. По этому намерению и по вашей фотографии целители будут представлять вас в вашем будущем таким (такой), как вы опишете в намерении.</p>

                <p>Для того, чтобы правильно составить намерение - посмотрите предложенное нами видео об этом.
                    Войдя в МОИ СЛОТЫ и нажав там на кнопку АНКЕТА I, Вы попадете в свою заполненную анкету,
                    а так же увидите перед анкетой ссылки на ЗУМ, по которому пройдет сеанс и ссылки на видео для подготовки к сеансу.
                    В том числе и на видео про намерения.
                </p>
                <p>Если Вы поймете, что написали неправильное намерение в своей анкете,
                    то его можно будет исправить, заполнив строку с Вашими намерениями по-другому и сохранив изменения,
                    нажав на кнопку СОХРАНИТЬ в конце анкеты.
                </p>

                <b>Важно:</b><br></br>

                <p>Записывайте намерение в виде короткой фразы

                    Используйте настоящее или прошедшее время

                    Не используйте будущее время

                    Не используйте глаголы ХОЧУ, МОГУ.

                    Не используйте отрицания

                    Составляйте намерения от первого лица единственного числа
                </p><br></br>

                <b>ВНИМАНИЕ!</b><br></br>
                <p>В случае, если Ваше намерение составлено неправильно,
                    Ведущий Исцеления предложит Вам изменить его на правильное прямо перед сеансом Исцеления.
                </p>

                <b>Пример неправильных намерений:</b><br></br>
                У меня нет рака<br></br>
                Я избавился от всех болей<br></br>

                Я хочу иметь детей<br></br>

                Я буду здоров<br></br>

                У меня нет страхов<br></br><br></br>

                <b>Пример правильных намерений:</b><br></br>

                Я здоров<br></br>

                Мой организм находится в балансе и наполнен энергией<br></br>

                Я наполнен любовью<br></br>

                У меня крепкий иммунитет<br></br>

                Пример : «Я здоров, цел и полон сил», «Мое сердце сильное и мощное», «Я передвигаюсь легко и свободно»
            </div><br></br>
            <div>
                <p>
                    Если намерение составлено неправильно, то для того, чтобы оно вам не навредило — наши ведущие оставляют за собой право изменить его, о чем вы узнаете на Исцелении.

                    Вы лично хотели бы получить сеанс исцеления? Если нет, Вы должны быть родителем/законным опекуном или лицом, имеющим доверенность или разрешение от Исцеляемого.
                </p>
                <label className="anketa-answer">
                    <b>
                        Пожалуйста, укажите, кем именно Вы приходитесь Исцеляемому
                        <span style={{ color: 'red' }}>*</span>
                    </b><br />
                    <div className="relation-buttons">
                        {options.map((option, index) => (
                            <button
                                key={option}
                                type="button"
                                className={relation === option ? 'active' : ''}
                                onClick={() => setRelation(option)}
                            >
                                {option}
                            </button>
                        ))}
                    </div>
                </label>


                <p>
                    Если человек, которого нужно исцелить — ребенок, пожалуйста, сообщите нам, сколько ему лет.
                    Если Исцеляемый не ребёнок, то сообщать его возраст не требуется.
                </p>
                <input
                    className="anketa_input"
                    type="text"
                    name="age"
                    value={form.age}
                    onChange={handleInputChange}
                    required
                    placeholder='Количество лет'
                />
            </div>

            <div>
                <b>Процесс проведения Сеанса Исцеления</b><br></br>

                <p>Исцеление проходит по зуму в виде групповой медитации совершенно бесплатно и занимает 50-55 минут.
                    Его проводят специально подготовленные Целители, прошедшие подготовку на недельных ретритах доктора Джо Диспензы и
                    практикующие с марта 2022 года.
                </p>

                <p>Время проведения сеанса Исцеления указывается по Московскому Времени.</p>

                <p>В Исцелении принимают участие от 4 исцеляемых кроме вас, ведущий и целители из единственной официальной
                    русско говорящей группы Когерентного Исцеления по методу доктора Джо Диспенза ЕДИНОЕ СЕРДЦЕ,
                    состоящей из 102 целителей.
                </p>
                <p>Для каждого Исцеляемого проводится отдельная медитация.
                    Приходите на Исцеление за 3-5 минут до указанного времени.
                    Желательно включать камеру, чтобы у Целителей сложился с вами более глубокий контакт (по вашему желанию). В любом случае, во время сеанса ведущий проведет презентацию исцеляемых, где покажет ваше фото, назовет ваше имя и фамилию и познакомит целителей с Вашим намерением на это исцеление (информация берется нами из Анкеты Исцеляемого).
                </p>
                <p>
                    Ведущий оставляет за собой право попросить Вас изменить намерение.
                </p>
                <p>
                    ПРОСИМ взять на себя ответственность и привести себя на сеанс Исцеления. Для этого - записать в календарях и поставить себе напоминания о дате и времени сеанса.

                    Мы напомним Вам о Вашем сеансе. За день до сеанса Вы получите письмо с напоминанием, которое придет на указанный Вами электронный адрес. По телефону или в мессенджерах с Вами связываться не будут.
                </p>
                <p>
                    {/* Если Вы не пришли на Исцеление - Исцеление будет проведено в любом случае.
                    Эффект от проведенного Исцеления будет практически такой же силы, как, если бы Вы приняли участие.
                    При этом Вы не сможете пережить и прочувствовать атмосферу любви, целостности и поддержки,
                    не переживете глубоких эмоций, появляющихся от живого общения с целителями и участия в трансформирующей медитации.
                    Не сможете выразить свою глубокую благодарность и признательность. */}
                    Просьба.<br></br>
                    Запланируйте исцеление и пожалуйста прочитайте эту памятку:<br></br>
                    -Каждый человек имеет право запланировать 2 встречи с интервалом 3 недели, все другие будут отменены<br></br>
                    -Все исцеляемые должны присутствовать на сеансе исцеления<br></br>
                    -Если исцеляемый не явиться на сеанс, его исцеление будет отменено<br></br>
                    -Если Вы по какой то причине не можете присутствовать на сеансе уведомите нас за 24 часа до начала.<br></br>

                    <p>
                        Выбор всегда остается за Вами!
                    </p>

                    Во время сеанса Вам необходимо расслабиться, принять удобную позу и довериться целителям, принимая их любовь и целительную энергию.
                    Медитация проводится для целителей. Вы можете присоединиться к целителям, когда будут исцелять других исцеляемых, но во время своей части исцеления расслабьтесь, доверьтесь и принимайте.
                </p><br></br>
                <h3>Ваша ответственность</h3>
                <h3>
                    Не забывайте! Вы и только вы несете ответственность за свою жизнь. Настройтесь на свое могущество и безоговорочно поверьте в свою силу!
                </h3>
                <h4>С уважением команда Единое Сердце</h4>
                <p>Для того, чтобы отправить нам данную заполненную Анкету - нажмите на кнопку СОХРАНИТЬ.</p>

                <button className='btn_save' onClick={handleSave}>Сохранить</button>

            </div>

        </div>
    );
}

export default Anketa;
